export { TooltipComponent } from "./tooltip.component";
export { TooltipDirective } from "./tooltip.directive";
export { TooltipModule } from "./tooltip.module";
